import React from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "react-bootstrap";

const Page404: React.FC = (props) => {
    const { t } = useTranslation("common");

    return (
        <Alert variant="warning">
            <Alert.Heading>404</Alert.Heading>
            <p>{t("error.notFound.message")}</p>
        </Alert>
    );
};

export default Page404;
